import axios, { AxiosResponse } from "axios";
import { getEnvVar } from "ideas.env";
import { getRequestHeaders } from "utils/getRequestHeaders";

type FetchDocsTemplateResponse = {
  docs_template: string;
};
/**
 * Fetches docs markdown for a tool version
 * @param toolVersionId
 * @returns a markdown string with the tool version docs template
 */
export const fetchToolVersionDocsTemplate = async (
  toolVersionId: number,
): Promise<FetchDocsTemplateResponse> => {
  const headers = await getRequestHeaders();

  const res = await axios.get<
    undefined,
    AxiosResponse<FetchDocsTemplateResponse>
  >(getEnvVar("URL_TRS_TOOL_VERSION_DOCS_TEMPLATE")(toolVersionId), {
    headers,
  });

  return res.data;
};
